import { render, staticRenderFns } from "./PieChartW.vue?vue&type=template&id=ff470a12&"
import script from "./PieChartW.vue?vue&type=script&lang=js&"
export * from "./PieChartW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports